import Dropdown from "../../../components/common/dropdown";

interface EquipmentProps {
    handleDropdown: (
        selectedValue: string,
        record: { [key: string]: string | boolean | number | undefined }
    ) => void;
    options: any;
    selectedValue: string;
}

export const Equipment = ({ handleDropdown, options, selectedValue }: EquipmentProps) => [
    {
        title: "Equipments",
        dataIndex: "equipments",
        key: "equipments",
        width: "40%",
        render: (_: string, record: { projectName: string; projectID: string }) => {
            return (
                <Dropdown
                    label=""
                    options={options}
                    onSelect={(option) => handleDropdown(option, record)}
                    selected={selectedValue}
                />
            );
        },
    },
    {
        title: "PN",
        dataIndex: "PN",
        key: "PN",
        width: "12%",
    },
    {
        title: "Length (ft)",
        dataIndex: "length",
        key: "length",
        width: "12%",
    },
    {
        title: "Weight (lbs)",
        dataIndex: "weight",
        key: "weight",
        width: "12%",
    },
    {
        title: "Diameter (in)",
        dataIndex: "diameter",
        key: "diameter",
        width: "12%",
    },
    {
        title: "Set depth (ft)",
        dataIndex: "setDepth",
        key: "setDepth",
        width: "12%",
    },   
];

export const equipmentColumns = [
    { title: "PN", key: "pn"},
    { title: "Length (ft)", key: "length"},
    { title: "Weight (lbs)", key: "weight"},
    { title: "Diameter (in)", key: "diameter",},
    { title: "Set depth (ft)", key: "setDepth"},
];
